import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import Loader from '@/components/common/Loader'
import { isSuperAdmin } from '@/lib/authorization'

const BlockedAccountsPage = lazy(() =>
  import(
    '@/features/superadmin/pages/BlockedAccountsPage/BlockedAccountsPage'
  ).then((m) => ({ default: m.default })),
)

export const Route = createFileRoute('/(app)/superadmin/blocked-accounts')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!isSuperAdmin(context.auth.userInfo)) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: BlockedAccountsRoute,
})

function BlockedAccountsRoute() {
  return (
    <Suspense
      fallback={
        <div className="h-page flex items-center justify-center">
          <Loader size="lg" />
        </div>
      }
    >
      <BlockedAccountsPage />
    </Suspense>
  )
}
